<template>
  <div class="bg-soft-grey-74 mt-6">
    <div class="container pt-5 p-2 pe-md-0 ps-md-0">
      <div class="row text-lg-start text-center">
        <div class="col-12 mb-4">
          <img class="fw-bold" style="width: 140px; height: 13px;"
            src="@/assets/img/logos/logo_grupo_2022_blanco_02.svg">
        </div>
        <!-- Columna 1 -->
        <div class="col-lg-2 col-md-3 col-6 col-sm-4">
          <ul class="list-unstyled small text-start">
            <li><a href="https://www.adrianmercado.com.ar/" class="text-white fw-bold text-decoration-none">
                Subastas en vivo</a></li>
            <li><a href="https://www.adrianmercado.com.ar/" class="text-white fw-bold text-decoration-none">
                Subastas cronometradas</a></li>
            <li><a href="https://www.adrianmercado.com.ar/subastas-vender"
                class="text-white fw-bold text-decoration-none">Vender</a></li>
            <li><a href="https://www.adrianmercado.com.ar/como-participar"
                class="text-white fw-bold text-decoration-none">Cómo participar</a></li>
            <li><a href="https://www.adrianmercado.com.ar/institucional"
                class="text-white fw-bold text-decoration-none">Quiénes somos</a></li>
          </ul>
        </div>

        <!-- Columna 2 -->
        <div class="col-lg-2 col-md-3 col-6 col-sm-4">
          <ul class="list-unstyled small text-start">
            <li><a href="https://www.adrianmercado.com.ar/medios"
                class="text-white fw-bold text-decoration-none">Medios</a></li>
            <li><a href="https://www.adrianmercado.com.ar/blog/"
                class="text-white fw-bold text-decoration-none">Novedades</a></li>
            <li><a href="https://www.adrianmercado.com.ar/es/comercio-exterior"
                class="text-white fw-bold text-decoration-none">Proyectos e inversiones</a></li>
            <li><a href="https://inmobiliaria.adrianmercado.com.ar/"
                class="text-white fw-bold text-decoration-none">Gestión Inmobiliaria</a></li>
          </ul>
        </div>

        <!-- Columna 3 -->
        <div class="col-lg-2 col-md-3 col-6 col-sm-4">
          <ul class="list-unstyled small text-start">
            <li><a href="https://www.adrianmercado.com.ar/certificaciones"
                class="text-white fw-bold text-decoration-none">Certificaciones</a></li>
            <li><a href="https://www.adrianmercado.com.ar/declaracion-privacidad"
                class="text-white fw-bold text-decoration-none">Declaración de privacidad</a></li>
            <li><a href="https://www.adrianmercado.com.ar/terminos"
                class="text-white fw-bold text-decoration-none">Términos y condiciones</a></li>
          </ul>
        </div>

        <!-- Columna 4 -->
        <div class="col-lg-2 col-md-3 text-start col-12 mt-3 mt-sm-3 mt-md-0">
          <p class="small fw-bold text-white mb-1">Contacto</p>
          <a href="https://www.google.com/maps/place/Olga+Cossettini+731,+Buenos+Aires/@-34.6058603,-58.3664461,17z/data=!3m1!4b1!4m5!3m4!1s0x95a3352eec00ff5d:0xde7dcbccb7a5b95!8m2!3d-34.6058603!4d-58.3642574?shorturl=1"
            class="small fw-bold text-white mb-1">Olga Cossettini 731, Piso 3.<br class="d-none d-md-block">C.A.B.A.
            [C1107CDA]<br class="d-none d-md-block"> República Argentina</a><br>
          <a class="small fw-bold text-white mb-1 d-none d-sm-block">Líneas Rotativas: (5411) 3984-7400</a>
        </div>

        <!-- Columna 5: Newsletter -->
        <div class="col-lg-3 ms-lg-4 col-lg-3 col-12 text-start">
          <div class="mt-4 d-flex d-md-none gap-3 justify-content-center mb-3">
            <a href="https://www.instagram.com/amsubastas/"><i class="fab fa-instagram text-white fs-4"></i></a>
            <a href="https://www.facebook.com/amsubastas/"><i class="fab fa-facebook text-white fs-4"></i></a>
            <a href="https://www.youtube.com/@adrianmercadosubastas"><i class="fab fa-youtube text-white fs-4"></i></a>
            <a href="https://www.linkedin.com/company/grupo-adri%C3%A1n-mercado/"><i class="fab fa-linkedin text-white fs-4"></i></a>
          </div>

          <p class="small text-white mb-1">Suscribite a nuestro newsletter</p>
          <form class="d-flex flex-row gap-2 mt-2">
            <input type="email" class="email form-control rounded-1 border-0" placeholder="Ingresar email"
              style="width: 212px;">
            <button class="btn btn-soft-dark fw-bold text-white">Suscribirme</button>
          </form>
          <!-- Redes sociales -->
          <div class="mt-4 d-none d-md-flex gap-3">
            <a href="#"><i class="fab fa-instagram text-white fs-5"></i></a>
            <a href="#"><i class="fab fa-facebook text-white fs-5"></i></a>
            <a href="#"><i class="fab fa-youtube text-white fs-5"></i></a>
            <a href="#"><i class="fab fa-linkedin text-white fs-5"></i></a>
          </div>
        </div>
      </div>

      <!-- Logos -->
      <div class="row justify-content-start mb-3 mt-5">
        <div class="col-auto d-flex flex-wrap gap-3 justify-content-center align-items-center">
          <img src="@/assets/img/logos/certificaciones/logo_iso_27001_2025.svg" alt="Logo" width="84" height="54">
          <img src="@/assets/img/logos/certificaciones/logo_iso_9001_2025.svg" alt="Logo" width="84" height="54">
          <img src="@/assets/img/logos/certificaciones/group.svg"  alt="Logo" width="84" height="54">
          <img src="@/assets/img/logos/certificaciones/google_site_seguro.svg" alt="Logo" width="74" height="25">
          <img src="@/assets/img/logos/certificaciones/logo_cace.svg" alt="Logo" width="53" height="26">
          <img src="@/assets/img/logos/certificaciones/gptw.png" alt="Logo" width="32" height="44">
          <img src="@/assets/img/logos/certificaciones/DATAWEB.jpg" alt="Logo" width="32" height="44">
        </div>
      </div>
    </div>

    <!-- Footer inferior -->
    <div class="bg-soft-black text-white text-start small py-2 px-3">
      <div class="container">
        Copyright © 2025 Adrián Mercado Subastas SA. Todos los derechos reservados. Mat. CPI (CUCICBA) Nº: 5604 - Mat.
        CMCPSI Nº: 3541. Somos miembros de: CAPIPE, CAPMIN y CACE - Adrián Mercado Subastas S.A. posee matrícula en:
        Colegio de Martilleros y Corredores Públicos de San Isidro (CMCPSI), Colegio de Martilleros Rosario (Jur. Santa
        Fe), Colegio Profesional de Martilleros y Corredores Públicos de La Provincia de Córdoba, Colegio de Martilleros
        Y
        Corredores Públicos de la provincia del Neuquén, Colegio de Martilleros Públicos de Entre Ríos.
      </div>
    </div>
  </div>
</template>

<style>
a {
  font-size: 13px;
}

p {
  font-size: 13px !important;
}

a:hover {
  color: #0452a7 !important;
}


@media (max-width: 768px) {

  .email {
    width: 540px !important;
    width: 100%;
  }
}

@media (max-width: 768px) {

  .email {
    width: 365px !important;
    width: 100%;
  }
}
</style>